/**
 * GENERATED_ASSET — adopted static Hush kit (sol61 batch001, CANDIDATE reviewed). Pure and browser-safe:
 * no node: imports and no game imports. Lantern, ribbon, reed and paper-boat families.
 */
import type { DraftArtifact } from './contracts';
import { Construction } from './construction';
import { buildPaperBoat } from './boat';
import { buildThreeWindowLantern } from './lantern';
import { buildReedCurtain } from './reeds';
import { buildCrookedRibbon } from './ribbon';

export type {
  DraftArtifact, LanternRecipe, PaletteRole, PaperBoatRecipe, RibbonRecipe, Point2, ProtectedVisualRegion, ReedCurtainRecipe, ResolvedPalette,
  StaticRecipe, Tokens, VisualAnchor, VisualBounds,
} from './contracts';
export { REVISION } from './contracts';
export { validateRecipe, validateTokens, ROLES } from './validation';
export { canonical } from './geometry';
export type { ReedStalkGeometry } from './reeds';
export { HUSH_RENDER_TOKENS } from './tokens';
export {
  HUSH_BOAT_PIP_CLUE, HUSH_LANTERN_SALT_WORN, HUSH_LANTERN_SALT_WORN_STANDING, HUSH_REEDS_CONCEALED, HUSH_REEDS_RETURN_OPEN, HUSH_RIBBON_REST,
} from './recipes';

/** Validate and build one static asset. `scope` prefixes every SVG definition id. */
export function buildStaticAsset(recipe: unknown, tokens: unknown, scope = 'hush_isolated'): DraftArtifact {
  const c = new Construction(recipe, tokens, scope);
  switch (c.recipe.generatorId) {
  case 'hush.lantern.v1': return buildThreeWindowLantern(c);
  case 'hush.ribbon.v1': return buildCrookedRibbon(c);
  case 'hush.reeds.v1': return buildReedCurtain(c);
  case 'hush.paper_boat.v1': return buildPaperBoat(c);
  }
}
